// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604241303/js/" + chunkId + "." + {"44":"4841c626","225":"8e06e547","481":"6d8a6fb7","486":"37d120dd","770":"9229a404"}[chunkId] + ".0.38273871566315454.chunk.js";
};